import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-trip-wizard-complete',
  templateUrl: './connect-trip-wizard-complete.component.html',
  styleUrls: ['./connect-trip-wizard-complete.component.scss'],
})
export class ConnectTripWizardCompleteComponent implements OnInit {
  @Output() reset = new EventEmitter()
  @Output() channel = new EventEmitter()
  @Output() done = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
